import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const UpcomingIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faCalendarDays} color="#EA466C" />;
};
